// src/data/workExperience.js
export const workExperienceData = [
  {
    id: 1,
    role: "Autonomous Vehicle Researcher",
    company: "Memorial University Department of Computer Science",
    location: "St. John's, NL",
    duration: "May 2023 - Dec 2023",
    durationMonths: 8,
    isTechnical: true,
    description:
      "Researched coordination mechanisms and strategies for autonomous vehicles, focusing on Vehicle to Everything communication and IoT integration.",
    responsibilities: [
      "Studied effective mechanisms for coordinating autonomous vehicle activities",
      "Researched intersection crossing, motorway entry, and platooning strategies",
      "Investigated parking optimization and traffic reduction solutions",
      "Worked with Vehicle to Everything communication protocols",
    ],
    technologies: [
      "Internet of Things",
      "Vehicle Communication",
      "Autonomous Systems",
      "Traffic Optimization",
    ],
    achievements: [
      "Developed coordination strategies for multiple vehicle scenarios",
      "Contributed to understanding of V2X communication systems",
    ],
    logo: "/assets/images/mun-logo.png",
  },
  {
    id: 2,
    role: "Resident Assistant",
    company: "Cluett Hall",
    location: "St. John's, NL",
    duration: "Sep 2022 - Apr 2025",
    durationMonths: 32,
    isTechnical: false,
    description:
      "Supporting student residents in Cluett Hall, creating a positive living environment and managing community activities.",
    responsibilities: [
      "Fostered a welcoming environment and encouraged open communication among residents",
      "Worked within the Rezlife framework, helping new RAs and improving through supervisor feedback",
      "Organized and executed various events and activities to build community",
      "Handled emergencies calmly, deescalated conflicts, and provided support when needed",
    ],
    technologies: [
      "Conflict Resolution",
      "Event Planning",
      "Conflict Deescalation",
    ],
    achievements: [
      "Received 'RA of the Year' award twice",
      "Successfully organized 15+ community-building events",
      "Achieved 95% resident satisfaction rating",
    ],
    logo: "/assets/images/cluett-logo.png",
  },
  {
    id: 3,
    role: "Coding Instructor",
    company: "Memorial Engineering Outreach Summer Camp",
    location: "St. John's, NL",
    duration: "May 2023 - Aug 2023, May 2024 - Aug 2024, May 2025 - Aug 2025",
    durationMonths: 12,
    isTechnical: true,
    description:
      "Teaching coding to students in grades 1-12, providing hands-on experience with programming concepts and technologies.",
    responsibilities: [
      "Provided coding lessons in Python, Java, and Arduino",
      "Conducted workshops on cybersecurity and privacy management",
      "Worked on robotics projects and troubleshooting various devices", //mac, dell xps, ipad, nintendo switch. Classroom technology
      //Mindstorm robots, Ev3 robots, Lunar Rover synchro, Arduino training. 
      "Collaborated with counselors to create engaging learning environment",
    ],
    technologies: ["Python", "Java", "Arduino", "Robotics", "Cybersecurity"],
    achievements: [
      "Developed custom curriculum for different age groups",
      "Received 100% positive feedback from students and parents",
      "Created reusable learning materials adopted by the program",
    ],
    logo: "/assets/images/engineering-logo.png",
  },
  {
    id: 4,
    role: "Science Orientation Coordinator",
    company: "Memorial University Faculty of Science",
    location: "St. John's, NL",
    duration: "May 2024 - Aug 2024, May 2025 - Aug 2025",
    durationMonths: 8,
    isTechnical: true,
    description:
      "Coordinated and oversaw the Faculty of Science Fall Orientation event hosting over 500 new Memorial University science students across two years.",
    responsibilities: [
      //worked as the Point of Contact for Departmentes, Faculty, Students and the Dean of Science's Office
      "Determined comprehensive schedule of events for orientation programming",
      "Coordinated volunteers and managed volunteer assignments", 
      //Managed a team of 25 volunteers and staff to cover the responsibilities of the event
      "Collaborated with university departments and community participants",
      "Assisted with promotional activities and marketing initiatives",
      //Facilitated 700+ students incoming to dept of science 
      "Helped create orientation materials and resources for new students",
      "Worked closely with faculty advisors and staff on assigned tasks",
    ],
    technologies: [
      "Event Management",
      "Volunteer Coordination",
      "Project Planning",
      "Marketing & Promotion",
    ],
    achievements: [
      "Successfully coordinated orientation for 500+ new science students across two years",
      "Managed multiple volunteer teams and university partnerships",
      "Developed reusable orientation frameworks and materials",
    ],
    logo: "/assets/images/mun-logo.png",
  },
  {
    id: 5,
    role: "University Governance Secretariat Student Assistant",
    company: "Memorial University Governance Secretariat",
    location: "St. John's, NL",
    duration: "Jan 2023 - Apr 2023",
    durationMonths: 4,
    isTechnical: true,
    description:
      "Assisted with digitalization of files for the University Governance Secretariat, supporting Senate, Board of Regents, and University Policy operations.",
    responsibilities: [
      "Digitalized files and documents for governance operations",
      "Supported Senate and Board of Regents administrative processes",
      "Assisted with University Policy documentation and management",
      "Conducted research projects for the Secretariat as needed",
      "Maintained organized digital filing systems",
    ],
    technologies: [
      "Document Management",
      "Digital Systems",
      "Policy Research",
      "Administrative Support",
    ],
    achievements: [
      "Completed 40 hours of governance support work",
      "Improved digital organization of university governance files",
      "Supported critical university decision-making processes",
    ],
    logo: "/assets/images/mun-logo.png",
  },
  {
    id: 6,
    role: "Professional Photographer",
    company: "Memorial University Residence Operations",
    location: "St. John's, NL",
    duration: "Jan 2023 - Apr 2023",
    durationMonths: 4,
    isTechnical: false,
    description:
      "Captured photos and video of residence operations, particularly guest accommodations, for web, social, and print media.",
    responsibilities: [
      "Conducted photo and video shoots of guestrooms, amenities, and services",
      "Photographed hallways, entrances, lobbies, and campus spaces",
      "Performed video post-production, photo retouching, and editing",
      "Organized, maintained, and updated photo collections",
      "Optimized content for social media platforms and online travel agencies",
    ],
    technologies: [
      "Photography",
      "Video Production",
      "Photo Editing",
      "Social Media Optimization",
      "Content Management",
    ],
    achievements: [
      "Completed 40 hours of professional photography work",
      "Created comprehensive visual content library for residence marketing",
      "Improved digital presence for university accommodations",
    ],
    logo: "/assets/images/mun-logo.png",
  },
  {
    id: 7,
    role: "Community Manager",
    company: "Reflective Teens",
    location: "Remote",
    duration: "Jan 2020 - Feb 2022",
    durationMonths: 26,
    isTechnical: false,
    description:
      "Led an international community, coordinated events, recruited team members, and ensured a safe and inclusive environment.",
    responsibilities: [
      "Managed online community of young writers and creators",
      "Organized virtual events and writing workshops",
      "Recruited and trained volunteer moderators",
      "Developed community guidelines and enforced standards",
    ],
    technologies: [
      "Community Management",
      "Content Moderation",
      "Event Planning",
      "Team Leadership",
    ],
    achievements: [
      "Grew community by 75% during tenure",
      "Successfully organized international virtual writing festival",
      "Launched mentorship program connecting young writers with professionals",
    ],
    logo: "/assets/images/rt-logo.png",
  },
  {
    id: 8,
    role: "PAL Leader (Peer-Assisted Learning)",
    company: "Memorial University Academic Success Centre",
    location: "St. John's, NL",
    duration: "Jan 2025 - Apr 2025",
    durationMonths: 4,
    isTechnical: false,
    description:
      "Facilitated weekly out-of-class group study sessions for Psychology 1001, providing academic support to students in historically challenging courses.",
    responsibilities: [
      "Attended all Psychology 1001 lectures and recruited session participants",
      "Conducted two 50-minute group study sessions per week",
      "Planned engaging sessions using effective learning strategies and facilitation techniques",
      "Completed administrative tasks including session planning and attendance documentation",
      "Maintained professional communication with course instructors and Supplemental Instruction Specialist",
      "Participated in pre-term training and ongoing professional development meetings",
    ],
    technologies: [
      "Educational Psychology",
      "Group Facilitation",
      "Learning Strategies",
      "Academic Support",
    ],
    achievements: [
      "Completed 80 hours of peer academic support work",
      "Successfully facilitated collaborative learning experiences for Psychology 1001 students",
      "Completed comprehensive PAL Leader training program",
    ],
    logo: "/assets/images/mun-logo.png",
  },
  {
    id: 9,
    role: "Blog Administrator",
    company: "Memorial University School of Social Work",
    location: "St. John's, NL",
    duration: "Jan 2022 - Apr 2022",
    durationMonths: 4,
    isTechnical: true,
    description:
      "Managed and maintained blog content and digital communications for the School of Social Work.",
    responsibilities: [
      "Administered blog content and publishing workflows",
      "Created and curated content for academic and professional audiences",
      "Managed digital communications for the School of Social Work",
      "Coordinated with faculty and staff for content development",
      "Maintained website functionality and user experience",
    ],
    technologies: [
      "Content Management Systems",
      "Digital Communications",
      "Web Administration",
      "Academic Publishing",
    ],
    achievements: [
      "Completed 38.5 hours of blog administration work",
      "Maintained consistent content publishing schedule",
      "Enhanced digital presence for School of Social Work",
    ],
    logo: "/assets/images/mun-logo.png",
    supervisor: "Delores Mullings",
  },
  {
    id: 10,
    role: "Events and Activities Assistant",
    company: "Marine Institution",
    location: "St. John's, NL",
    duration: "Jan 2022 - Apr 2022",
    durationMonths: 4,
    isTechnical: false,
    description:
      "Assisted with planning, coordination, and execution of university events and student activities.",
    responsibilities: [
      "Supported event planning and logistics coordination",
      "Assisted with setup and breakdown of university events",
      "Coordinated with student groups and external vendors",
      "Managed event registration and attendee communications",
    ],
    technologies: [
      "Event Planning",
      "Logistics Coordination",
      "Student Engagement",
      "Administrative Support",
    ],
    achievements: [
      "Successfully supported multiple large-scale university events",
      "Improved event organization processes",
      "Enhanced student participation in campus activities",
    ],
    logo: "/assets/images/mun-logo.png",
  },
];
